
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/base/Card';
import Button from '../../../components/base/Button';

export default function ProductsSection() {
  const [activeCategory, setActiveCategory] = useState('todos');
  const navigate = useNavigate();

  const categories = [
    { id: 'todos', name: 'Todos os Produtos' },
    { id: 'culinarios', name: 'Culinários' },
    { id: 'sobremesas', name: 'Sobremesas' },
    { id: 'bebidas', name: 'Bebidas' },
    { id: 'industrial', name: 'Linha Industrial' }
  ];

  const products = [
    {
      id: 1,
      name: 'Amaciante de Carnes',
      category: 'culinarios',
      image: '/products/amaciante-carnes.png',
      description: 'Produto que amacia até 34 Kg de carne'
    },
    {
      id: 2,
      name: 'Pudim com Leite',
      category: 'sobremesas',
      image: '/products/pudim-leite.png',
      description: 'Pudim cremoso e saboroso'
    },
    {
      id: 3,
      name: 'Gelatina Zero Açúcares',
      category: 'sobremesas',
      image: '/products/gelatina-zero.png',
      description: 'Sabor maçã verde, qualidade garantida'
    },
    {
      id: 4,
      name: 'Chocolate em Pó 50% Cacau',
      category: 'bebidas',
      image: '/products/chocolate-50.png',
      description: 'Chocolate premium para bebidas'
    },
    {
      id: 5,
      name: 'Farinha Para Empanar Panko',
      category: 'industrial',
      image: '/products/farinha-panko.png',
      description: 'O ingrediente que faltava no seu menu'
    },
    {
      id: 6,
      name: 'Mistura Para Tempura',
      category: 'industrial',
      image: '/products/mistura-tempura.png',
      description: 'Perfeita para pratos orientais'
    },
    {
      id: 7,
      name: 'Proteína de Soja Texturizada',
      category: 'industrial',
      image: '/products/proteina-soja-15kg.png',
      description: 'Embalagem de 15 Kg'
    },
    {
      id: 8,
      name: 'Mousse',
      category: 'sobremesas',
      image: '/products/mousse.png',
      description: 'Sobremesa cremosa e deliciosa'
    }
  ];

  const filteredProducts = activeCategory === 'todos' 
    ? products 
    : products.filter(product => product.category === activeCategory);

  const handleViewDetails = (productId: number) => {
    // Navegar para a página de produtos com foco no produto específico
    navigate(`/produtos?produto=${productId}`);
  };

  const handleViewAllProducts = () => {
    navigate('/produtos');
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-red-600 font-semibold text-lg">Novidades da nossa linha</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-2 mb-4">
            Nossos Produtos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubra nossa linha completa de produtos para food service, desenvolvidos com a mais alta qualidade
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12" data-product-shop>
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all duration-200 whitespace-nowrap ${
                activeCategory === category.id
                  ? 'bg-red-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-red-50 hover:text-red-600 shadow-md'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-product-shop>
          {filteredProducts.map((product) => (
            <Card key={product.id} hover className="group cursor-pointer">
              <div className="aspect-square mb-4 overflow-hidden rounded-lg bg-gray-100">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.onerror = null;
                    target.src = `https://placehold.co/400x400/ef4444/ffffff?text=${encodeURIComponent(product.name)}`;
                  }}
                />
              </div>
              <h3 className="font-semibold text-lg text-gray-900 mb-2 group-hover:text-red-600 transition-colors">
                {product.name}
              </h3>
              <p className="text-gray-600 text-sm mb-4">
                {product.description}
              </p>
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full"
                onClick={() => handleViewDetails(product.id)}
              >
                Ver Detalhes
              </Button>
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button size="lg" onClick={handleViewAllProducts}>
            <i className="ri-eye-line mr-2"></i>
            Ver Todos os Produtos
          </Button>
        </div>
      </div>
    </section>
  );
}
